import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import 'echarts-liquidfill/src/liquidFill.js'; // 引入提示框

require('echarts/lib/component/tooltip'); // 引入标题组件


require('echarts/lib/component/title');

require('echarts/lib/component/legendScroll');

import { getAction } from '@/api/manage'; // 日期格式化插件

import moment from 'moment';
import { queryWarn, queryRealtime, querySiteList as _querySiteList } from '@/api/api'; // 水文监测

import hydrology from '@comp/bigData/hydrology-jinchu'; // 水质监测

import waterStatistics from '@comp/bigData/waterStatistics-jinchu'; // 水文监测

import waterWenStatistics from '@comp/bigData/waterWenStatistics-jinchu';
import hydrologyWen from '@comp/bigData/hydrology-wen-jinchu';
import screenfull from 'screenfull';
var scrollTimer;
var dateTimer;
var timer;
export default {
  data: function data() {
    return {
      headDate: '',
      headWeek: '',
      headTime: '',
      waterWarnList: [],
      isFullscreen: false,
      dataMap: {},
      activeKey: '1',
      imgStatus: 0,
      remark: '',
      imgSrc: '',
      title: '10kV进线断路器',
      swiperIndex: 0,
      swiperIndex2: 0,
      swiperIndex3: 0
    };
  },
  mounted: function mounted() {
    moment.locale('zh-cn');
  },
  components: {
    hydrology: hydrology,
    waterStatistics: waterStatistics,
    waterWenStatistics: waterWenStatistics,
    hydrologyWen: hydrologyWen
  },
  methods: {
    initData: function initData() {
      var _this = this;

      this.getWarn();
      scrollTimer = setInterval(this.scroll, 1000);
      this.querySiteList();
      dateTimer = setInterval(function () {
        var date = new Date();
        _this.headDate = moment(date).format('YYYY年MM月DD日');
        _this.headWeek = moment(date).format('dddd');

        _this.swiper();

        _this.changeKey(_this.activeKey, true);
      }, 60000);
      this.getDate();
      this.getInfo();
    },
    clearTimer: function clearTimer() {
      clearInterval(scrollTimer);
      clearInterval(dateTimer);
      clearInterval(timer);
    },
    swiper: function swiper() {
      if (this.swiperIndex < 1) {
        this.$refs.swiper1.goTo(this.swiperIndex + 1);
      } else {
        this.$refs.swiper1.goTo(0);
      }

      if (this.swiperIndex2 < 1) {
        this.$refs.swiper2.goTo(this.swiperIndex2 + 1);
      } else {
        this.$refs.swiper2.goTo(0);
      }

      if (this.swiperIndex3 < 1) {
        this.$refs.swiper3.goTo(this.swiperIndex3 + 1);
      } else {
        this.$refs.swiper3.goTo(0);
      }
    },
    afterChange: function afterChange(e) {
      this.swiperIndex = e;
    },
    afterChange2: function afterChange2(e) {
      this.swiperIndex2 = e;
    },
    afterChange3: function afterChange3(e) {
      this.swiperIndex3 = e;

      if (e == 0) {
        this.title = '10kV进线断路器';
      } else {
        this.title = '站变组断路器';
      }
    },
    changeKey: function changeKey(key, flag) {
      if (flag) {
        if (Number(key) < 5) {
          this.activeKey = Number(key) + 1 + '';
        } else {
          this.activeKey = '1';
        }
      } else {
        this.activeKey = key;
      }

      if (this.activeKey == '1') {
        if (this.dataMap['u43901'].value == 1) {
          this.imgStatus = 1;
        } else {
          this.imgStatus = 0;
        }
      } else if (this.activeKey == '2') {
        if (this.dataMap['u43902'].value == 1) {
          this.imgStatus = 1;
        } else {
          this.imgStatus = 0;
        }
      } else if (this.activeKey == '3') {
        if (this.dataMap['u43903'].value == 1) {
          this.imgStatus = 1;
        } else {
          this.imgStatus = 0;
        }
      } else if (this.activeKey == '4') {
        if (this.dataMap['u43904'].value == 1) {
          this.imgStatus = 1;
        } else {
          this.imgStatus = 0;
        }
      } else {
        this.imgStatus = 0;
      }
    },
    toData: function toData() {
      this.$router.push('/ds/index');
    },
    getInfo: function getInfo() {
      var that = this;
      var params = {
        type: '1',
        id: '8'
      }; // 污水站点

      queryRealtime(params).then(function (res) {
        if (res) {
          if (res.result.records.length > 0) {
            that.dataMap = res.result.records[0].dataMap || null;
          } else {
            that.dataMap = null;
          }
        }
      });
    },
    querySiteList: function querySiteList() {
      var _this2 = this;

      var that = this; // 污水站点

      _querySiteList({
        id: '8'
      }).then(function (res) {
        if (res) {
          _this2.remark = res.result.records[0].remark;
          _this2.imgSrc = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
        }
      });
    },
    fullscreen: function fullscreen() {
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    },
    getDate: function getDate() {
      var _this3 = this;

      var date = new Date();
      this.headDate = moment(date).format('YYYY年MM月DD日');
      this.headWeek = moment(date).format('dddd');
      this.headTime = moment(date).format('HH:mm:ss');
      timer = setInterval(function () {
        var time = new Date();
        _this3.headTime = moment(time).format('HH:mm:ss');

        _this3.$forceUpdate();
      }, 1000);
    },
    scroll: function scroll() {
      var _this4 = this;

      setTimeout(function () {
        if (_this4.waterWarnList.length > 5) {
          _this4.waterWarnList.push(_this4.waterWarnList[0]); // 将数组的第一个元素添加到数组的


          _this4.waterWarnList.shift(); //删除数组的第一个元素

        }
      }, 500);
    },
    getWarn: function getWarn() {
      var that = this;
      var params = {
        pageNo: 1,
        pageSize: 10,
        scopeId: '8',
        scope: 1,
        st: 53
      }; // 污水站点

      queryWarn(params).then(function (res) {
        if (res) {
          that.waterWarnList = res.result.records;
        }
      });
    },
    goHome: function goHome() {
      this.$router.push('/monitor/map');
    }
  }
};